import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/wine-event-booking", {
	title: "Wine Event booking",
	icon: {
		src: <Icon icon="portfolio" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Book wine tasting event slot.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
